import { useEffect, useMemo } from "react";

type SelectOption<T> = Readonly<{ value: T; disabled?: boolean }>;
type UseAutoSelectSingleOptionResult = Readonly<{ locked: boolean }>;

/**
 * Auto-selects the only enabled option and reports when the field should be locked.
 */
export function useAutoSelectSingleOption<T>(
  options: ReadonlyArray<SelectOption<T>> | undefined,
  value: T | undefined,
  onChange: (value: T) => void
): UseAutoSelectSingleOptionResult {
  const onlyValue = useMemo(() => {
    let only: T | undefined;
    for (const option of options ?? []) {
      if (option.disabled) continue;
      if (only !== undefined) return undefined;
      only = option.value;
    }
    return only;
  }, [options]);

  useEffect(() => {
    if (onlyValue === undefined || onlyValue === value) return;
    onChange(onlyValue);
  }, [onChange, onlyValue, value]);

  return { locked: onlyValue !== undefined };
}
